module.exports = __webpack_public_path__ + "static/media/29.3fa6e419.jpg";